import { FC } from "react";

import { Grid } from "@mui/material";
import { ClearSearchButton, FilterByDownloadDateTypes, FilterForm } from "../Filters";
import { FilterPublishedImports } from "../common/FilterPublishedArtifacts";

export interface IDateRange {
  start?: string;
  end?: string;
}

interface ICreateDefaultImportStatusFilters {
  project?: string | null;
  importName?: string | null;
  bundleName?: string | null;
}
// Shared so the factory's return type and the onChange setter cannot drift apart.
export interface IImportStatusFilter {
  dateRangeType: string;
  importName?: string | null;
  project?: string | null;
  bundleName?: string | null;
}

const createDefaultImportStatusFilters = ({
  project,
  importName,
  bundleName,
}: ICreateDefaultImportStatusFilters): IImportStatusFilter => {
  return { dateRangeType: "reportDate", importName, project, bundleName };
};

interface IImportStatusFilters {
  dateRangeType: string;
  importName?: string | null;
  bundleName?: string | null;
  project?: string | null;
  onChange: React.Dispatch<React.SetStateAction<IImportStatusFilter>>;
  onClear: () => void;
}

const ImportStatusFilters: FC<IImportStatusFilters> = ({
  dateRangeType,
  importName,
  bundleName,
  project,
  onChange,
  onClear,
}) => {
  const getCurrent = () => {
    return { dateRangeType, importName, project, bundleName };
  };

  const handleChange = (newFilters: Partial<IImportStatusFilter>) => {
    onChange(Object.assign({}, getCurrent(), newFilters));
  };

  return (
    <FilterForm>
      <Grid>
        <FilterByDownloadDateTypes
          dateRangeType={dateRangeType}
          onChange={(value) => handleChange({ dateRangeType: value ?? "" })}
        />
      </Grid>
      <Grid>
        <FilterPublishedImports
          id="downloadsImportSelect"
          projectName={project}
          importName={importName}
          bundleName={bundleName}
          onChange={handleChange}
          allowSelectProjects={true}
          allowSelectSuspended={true}
        />
      </Grid>
      <Grid sx={{ marginTop: "20px" }}>
        <ClearSearchButton onClear={onClear} />
      </Grid>
    </FilterForm>
  );
};

export { createDefaultImportStatusFilters, ImportStatusFilters };
